/**
* This enumeration contains the Action Type string constants for Event Published Info
*/
enum ActionType {
    SET_EVENT_PUBLISHED_INFO = 'EventEditActions.ON_SET_EVENT_PUBLISHED_INFO',
}

export default ActionType;
